module.exports = __webpack_public_path__ + "static/media/ArrowRight.d91893f5.svg";